import React from "react";
import { ReactComponent as PotionsLogo } from "../../assets/icons/potions-logo-full.svg";
import { isWhiteLabel } from "../../services/agencyService";

interface MfaModalProps {
  children: React.ReactNode;
  onClose?: () => void;
}

const MfaModal: React.FC<MfaModalProps> = ({ children, onClose }) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div className="mfa-backdrop" onClick={handleBackdropClick}>
      <div className="mfa-card">
        {!isWhiteLabel() && (
          <div className="mfa-card-header">
            <PotionsLogo style={{ height: 32, display: "block" }} />
          </div>
        )}
        <div className="mfa-card-body">{children}</div>
      </div>
    </div>
  );
};

export default MfaModal;
